export default __webpack_public_path__ + "static/media/store.inline.1fe2470e.svg";